import { TextComponent } from 'baseComponents/TextComponent';
import './IosPushPreview.scss';
import pjLogo from 'assets/images/pushPjlogo.svg';
import { truncateText } from 'utils/text';

export type IosPushPreviewProps = {
  title: string;
  body: string;
  time: string;
};

export const IosPushPreview = ({ title, body, time }: IosPushPreviewProps) => (
  <div className='ios-push-preview'>
    <TextComponent text='iOS Preview' size='middle' weight='extra-bold' />
    <div className='ios-push-preview__wrapper push-preview__body'>
      <div className='ios-push-preview__content'>
        <div className='ios-push-preview__header'>
          <img src={pjLogo} alt='app icon' className='ios-push-preview__icon' />
        </div>
        <div className='ios-push-preview__body'>
          <TextComponent text={title} weight='extra-bold' size='small' />
          <TextComponent
            text={truncateText(body)}
            weight='extra-light'
            size='small'
          />
        </div>
        <TextComponent
          text={time}
          weight='extra-light'
          size='extra-small'
          opacity
          className='ios-push-preview__time'
        />
      </div>
    </div>
  </div>
);
